// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { UpdatedMultiSelectAsync } from 'components/Form'
import { getContactOptions } from './helpers'

const ContactField = props => {
  const {
    idRoot,
    name,
    sourceForm,
  } = props

  return (
    <Field
      className={'contact'}
      component={UpdatedMultiSelectAsync}
      id={`${idRoot}-contact-code`}
      label={'Contact Code'}
      labelKey={'contactCode'}
      name={name}
      optionsResource={getContactOptions}
      sourceForm={sourceForm}
      valueKey={'contactId'} />
  )
}

ContactField.propTypes = {
  idRoot: string.isRequired,
  name: string.isRequired,
  sourceForm: string.isRequired,
}

export default ContactField
